(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // (function () {
  //   var base = 100;
  //   window.addEventListener('scroll', function () {
  //     var scroll = window.scrollY || window.pageYOffset;
  //     document.querySelectorAll('.scroll-up-sticky header-drawer .menu-drawer').forEach(function (el) {
  //       // 100px sudhi custom effect
  //       if (scroll <= base) {
  //         var topVal = base - scroll;
  //         el.style.top = topVal + 'px';
  //         el.style.height = 'calc(100svh - ' + topVal + 'px)';
  //       }
  //       // 100px pachi original CSS restore
  //       else {
  //         el.style.top = '';
  //         el.style.height = '';
  //       }
  //     });
  //   });
  // })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    


  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
      const form = document.querySelector('.variant-picker__form');
      const buyButtons = document.querySelector('.buy-buttons-block');
      if (!form || !buyButtons) return;
      form.addEventListener('change', function (e) {
        if (!e.target.matches('input, select, textarea')) return;
        buyButtons.classList.add('disable');
        setTimeout(() => {
          buyButtons.classList.remove('disable');
        }, 1500);
      });
    }, 1000);
  });


// thumbnail move with slider
(function () {
  let startX = 0;
  let endX = 0;
  const thumbnailsWrapper = document.querySelector('.slideshow-controls__thumbnails');
  const swipeTarget = document.querySelector('.product-information__grid.slideshow-slides');
  function scrollActiveThumbnail() {
    if (!thumbnailsWrapper) return;
    const activeBtn = thumbnailsWrapper.querySelector(
      'button[aria-selected="true"]'
    );
    if (!activeBtn) {
      return;
    }
    activeBtn.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  }
  if (swipeTarget) {
    swipeTarget.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });
    swipeTarget.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) < 50) return;
      setTimeout(scrollActiveThumbnail, 50);
    });
  }
  if (thumbnailsWrapper) {
    const observer = new MutationObserver(() => {
      scrollActiveThumbnail();
    });

    observer.observe(thumbnailsWrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });
  }
  window.addEventListener('load', () => {
    setTimeout(scrollActiveThumbnail, 100);
  });
})();
// thumbnail move with slider

  } catch(e) { console.error(e); }
})();
})();
